import { render, staticRenderFns } from "./FormRow.vue?vue&type=template&id=507677de&scoped=true&"
import script from "./FormRow.vue?vue&type=script&lang=ts&"
export * from "./FormRow.vue?vue&type=script&lang=ts&"
import style0 from "./FormRow.vue?vue&type=style&index=0&id=507677de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507677de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
